import { TableCell } from "../ui/table";
import { DropdownMenu, Action } from "../DropdownMenu";
import { DotsVerticalIcon } from "@heroicons/react/solid";

export const TableActions = <DataType,>({
  actions,
  item,
}: {
  actions?: Action<DataType>[];
  item: DataType;
}) => {
  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <TableCell className="flex justify-end">
      <DropdownMenu<DataType>
        menuItems={actions}
        item={item}
        icon={<DotsVerticalIcon className="h-5 w-5 text-gray-500" />}
      />
    </TableCell>
  );
};
